import script from "./HelpDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpDialog.vue?vue&type=script&setup=true&lang=js"

import "./HelpDialog.vue?vue&type=style&index=0&id=1b91711c&scoped=true&lang=css"
import "./HelpDialog.vue?vue&type=style&index=1&id=1b91711c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b91711c"]])

export default __exports__